import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles'; // to get current MUI theme

import { styled } from '@mui/material/styles';

const WisContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: '10px',
});

const WisLabel = styled(Typography)(({ theme }) => ({
  fontFamily: "'JLR Emeric', sans-serif",
  fontStyle: 'normal',
  fontWeight: 600,
  fontSize: '28px',
  lineHeight: '35px',
  color: theme.palette.mode === 'dark' ? '#FFFFFF' : '#202020',
  display: 'flex',
  alignItems: 'center',
}));

const ToggleContainer = styled(Box)(({ isOn }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  padding: '4px',
  gap: '10px',
  width: '54px',
  height: '22px',
  background: isOn ? '#3d3c3cff' : '#D6D6D6',
  borderRadius: '100px',
  cursor: 'pointer',
  transition: 'background-color 0.3s ease',
}));

const ToggleCircle = styled(Box)(({ isOn }) => ({
  width: '14px',
  height: '14px',
  background: '#FFFFFF',
  borderRadius: '50%',
  flex: 'none',
  order: 0,
  flexGrow: 0,
  transform: isOn ? 'translateX(32px)' : 'translateX(0px)',
  transition: 'transform 0.3s ease',
}));

const WisToggle = ({ isOn, onToggle }) => {
  	const theme = useTheme();	

  const handleToggle = () => {
    const newValue = !isOn;
    if (onToggle) {
      onToggle(newValue);
    }
  };

  return (
    <WisContainer>
      <WisLabel>WIS</WisLabel>
      <ToggleContainer isOn={isOn} onClick={handleToggle}>
        <ToggleCircle isOn={isOn} />
      </ToggleContainer>
    </WisContainer>
  );
};

export default WisToggle;
